import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LabelDescription from '../../LabelDescription';
import './styles.css';

class BodyLeftRowLabel extends Component {
	render() {
		const { label, description } = this.props;
		return (
			<div className="sales-test-layout-body-left-row-label">
				<LabelDescription label={label} description={description} />
			</div>
		);
	}
}

BodyLeftRowLabel.propTypes = {
	label: PropTypes.string,
	description: PropTypes.string
};
export default BodyLeftRowLabel;
